import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=2c468406&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=ts"
export * from "./PersonalSettings.vue?vue&type=script&lang=ts"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=2c468406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c468406",
  null
  
)

export default component.exports